export default __webpack_public_path__ + "not_found.png";